import ProjectCreationModel from "../models/project-creation-model.ts";
import ProjectCreationReducerAction from "./project-creation-reducer-action.ts";

const ProjectCreationReducer: (
    draft: ProjectCreationModel,
    action: ProjectCreationReducerAction
) => void = (draft, action) => {
    switch (action.type) {
        case 'setInformations':
            draft.setName(action.payload.name);
            draft.setLocalisationId(action.payload.localisationId);
            return draft;
        case 'populateBuildings':
            draft.setBuildings(action.payload);
            return draft;
        default: {
            throw new Error(`Unknown action`);
        }
    }
}

export default ProjectCreationReducer;